export default __webpack_public_path__ + "static/verso-4-3eb1831dba54f59523e3312be741ad44.jpg";